import Vue from 'vue'
import Vuex from 'vuex'
import SecureLS from 'secure-ls'
import createPersistedState from 'vuex-persistedstate';
import system_data from './module/system'
import form_rules from './module/form_rules'
import authentication from './module/authentication'
import users from './module/user'
import branch_information from './module/data/branch_information'
import members_information from './module/data/members_information'
import business_owners from './module/data/business_owners'
import bank_depositories from './module/data/bank_depositories'
import deposit_slips from './module/data/deposit_slips'
import members_payments from './module/data/members_payments'
import branch_data from './module/data/branch_data'
import branch_data_payments from './module/data/branch_data_payments'
import transaction_month from './module/data/transaction_month'
import general_manager_incentives from './module/data/general_manager_incentives'

const ls = new SecureLS({
  isCompression: false,
})
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState(
    {
      key: 'GGC-GL BUILDINGS',
      paths: ['authentication'],
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    },
  )],
  state: {},
  mutations: {},
  actions: {},
  modules: {
    system_data,
    form_rules,
    authentication,
    users,
    branch_information,
    members_information,
    business_owners,
    bank_depositories,
    deposit_slips,
    members_payments,
    branch_data,
    branch_data_payments,
    transaction_month,
    general_manager_incentives,
  },
})
